import { LocalStorageService } from "../services/LocalStorageService"
import config, { APP_VERSION, postMessageWhiteList } from '../constants/Configs';
import { changePopupVisibility, changeMyProfilePopupVisibility, getControls } from '../actions/ControlsAction'
import { PopupEnum } from './base/PopupEnum';
import ProfileEnum from './myProfile/payments/enums/ProfileEnum'
import { updateLogo } from '../actions/SettingsAction';
import { LanguageService } from '../services/LanguageService';
import store from '../index';
import history from '../services/History';
import { Constants } from '../constants/Constants'
import { getBanners, getImageSet } from '../actions/BannersAction'
import { getPlayerData, getAccountWallets } from '../actions/UserActions';
import { getSettingsSuccess, setColorMode } from '../actions/settings/SettingsAction';
import { Auth } from '../services/Auth';
import Utils from "../services/Utils";
import { setPromotionKey } from '../actions/PromotionsAction'
import { getBackgrounds } from "../actions/PagesActions";
import { getAnnouncements } from "../actions/AnnouncementsAction";
import { CustomisationHelper } from '../services/helpers/CustomisationHelper'
import { changePopupSettings } from "../actions/PopupAction";
import { getStories } from "../actions/StoriesActions";
import BuilderActionsEnum from "../constants/Enums/BuilderActionsEnum";
import SportHelper from "../services/helpers/sport/SportHelper";

//import { ColorModeSportNameEnum } from "../constants/Enums/UiEnum";
Utils.resetPreviewMode();
window.top.postMessage({ action: "onLoad", data: APP_VERSION }, "*");

export const BuilderInteractions = {
    listener: (event) => {

        const domainMatch = event.origin.match(/([a-z0-9-]*?)\.[a-z]{2,}$/);
        const domain = domainMatch && domainMatch[0];

        if (postMessageWhiteList.indexOf(domain) < 0) {
            return;
        }

        let data;

        try {
            data = typeof event.data === 'string' ? (!event.data.startsWith('webpack') ? JSON.parse(event.data) : {}) : {};
        } catch {
            data = {};
        }

        const { payload, action } = data;


        if (action) {
            Utils.setPreviewMode();
        }


        switch (action) {
            case BuilderActionsEnum.ClearLocalStorage:
                LocalStorageService.clear();
                break;
            case BuilderActionsEnum.ChangeColors:
                BuilderInteractions.handleColorChange(data)
                break;
            case BuilderActionsEnum.ChangePopupColor:
                BuilderInteractions.handleColorChange(data)
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.MyProfile,
                        subTab: 0
                    }));

                } else {
                    store.dispatch(changePopupVisibility(PopupEnum.Login));
                }
                break;
            case BuilderActionsEnum.ChangeBorderRadius:
                if (payload.borderRadius.btnTopLeft) {
                    document.documentElement.style.setProperty('--btn-radius-top-left', payload.borderRadius.btnTopLeft);
                    document.documentElement.style.setProperty('--btn-radius-top-right', payload.borderRadius.btnTopRight);
                    document.documentElement.style.setProperty('--btn-radius-bottom-left', payload.borderRadius.btnBottomLeft);
                    document.documentElement.style.setProperty('--btn-radius-bottom-right', payload.borderRadius.btnBottomRight);

                    document.documentElement.style.setProperty('--odd-radius-top-left', payload.borderRadius.btnTopLeft);
                    document.documentElement.style.setProperty('--odd-radius-top-right', payload.borderRadius.btnTopRight);
                    document.documentElement.style.setProperty('--odd-radius-bottom-left', payload.borderRadius.btnBottomLeft);
                    document.documentElement.style.setProperty('--odd-radius-bottom-right', payload.borderRadius.btnBottomRight);
                }
                if (payload.borderRadius.inputBottomLeft) {
                    document.documentElement.style.setProperty('--input-radius-top-left', payload.borderRadius.inputLeftTop);
                    document.documentElement.style.setProperty('--input-radius-top-right', payload.borderRadius.inputTopRight);
                    document.documentElement.style.setProperty('--input-radius-bottom-left', payload.borderRadius.inputBottomLeft);
                    document.documentElement.style.setProperty('--input-radius-bottom-right', payload.borderRadius.inputBottomRight);
                }
                break;
            case BuilderActionsEnum.FontChange:
                // Object.keys(payload).forEach(font => {
                //   document.documentElement.style.setProperty(`--${font}`, payload[font]);
                // });
                if (payload['font-family-1'].indexOf('Roboto') >= 0 && !document.getElementById("roboto-font")) {
                    const link1 = document.createElement('link');
                    link1.rel = "preconnect";
                    link1.href = "https://fonts.gstatic.com";
                    const link2 = document.createElement('link');
                    link2.id = "roboto-font";
                    link2.rel = "stylesheet";
                    link2.href = "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap";
                    document.head.appendChild(link1)
                    document.head.appendChild(link2)
                } else if (payload['font-family-1'].indexOf('IRANSans') >= 0 && !document.getElementById("iran-sans-custom-font")) {
                    const customLink = document.createElement('link');
                    customLink.rel = "stylesheet";
                    customLink.id = "iran-sans-custom-font";
                    customLink.href = `${config.DEFAULT_SITE_URL}/css/fonts/iranSans.css`;
                    document.head.appendChild(customLink);
                } else if (payload['font-family-1'].indexOf('OpenSans') >= 0 && !document.getElementById("open-sans-font")) {
                    const link3 = document.createElement('link');
                    link3.id = "open-sans-font";
                    link3.rel = "stylesheet";
                    link3.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap";
                    document.head.appendChild(link3);
                } else if (payload['font-family-1'].indexOf('Ubuntu') >= 0 && !document.getElementById("ubuntu-font")) {
                    const link4 = document.createElement('link');
                    link4.id = "ubuntu-font";
                    link4.rel = "stylesheet";
                    link4.href = "https://fonts.googleapis.com/css2?family=Ubuntu:wght@300;400;500;600;700&display=swap";
                    document.head.appendChild(link4);
                }
                document.documentElement.style.setProperty('--font-family-1', payload['font-family-1']);
                typeof (Event) === 'function' && window.dispatchEvent(new Event('resize'));
                break;
            case BuilderActionsEnum.ImageSet:
                store.dispatch(getImageSet(data.payload?.id, Utils.isTablet() ? 'Mobile' : 'Desktop'));
                break;
            case BuilderActionsEnum.MoveMenuItem:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                const section = payload === 'accountMenu' ? 'header' : payload;
                store.dispatch(getControls(section, payload === 'header')).then((res) => {
                    if (payload === 'accountMenu' && Auth.isAuthenticated() && !Utils.isMobile()) {
                        setTimeout(() => {
                            let accountMenu = document.querySelector('.account-block_user-select .item__right-side');
                            accountMenu && accountMenu.click();
                        }, 1600)
                    }
                });
                break;
            case BuilderActionsEnum.ChangeMenuItem:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                store.dispatch(getControls(payload.type === 'accountMenu' ? 'header' : payload.type, payload.type === 'header', !!payload.w)).then((res) => {
                    if (payload.type === 'accountMenu' && Auth.isAuthenticated() && !Utils.isMobile()) {
                        setTimeout(() => {
                            let accountMenu = document.querySelector('.account-block_user-select .item__right-side');
                            accountMenu && accountMenu.click();
                        }, 1600)
                    }
                });

                break;
            case 'language_bar':
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                const languageBarmodel = payload.model
                if (languageBarmodel) {
                    // languageBarmodel.isVisible
                    // languageBarmodel.properties.type
                } else {
                    // store.dispatch(getControls(payload.section, payload.section === 'header'));
                }
                break;
            case BuilderActionsEnum.Login:
                store.dispatch(changePopupVisibility(PopupEnum.Login));
                store.dispatch(getControls(payload));
                break;
            case BuilderActionsEnum.RecoverPassword:
                store.dispatch(changePopupVisibility(PopupEnum.RecoverPassword));
                store.dispatch(getControls(payload));
                break;
            case BuilderActionsEnum.ForgotPassword:
                store.dispatch(changePopupVisibility(PopupEnum.ForgotPassword));
                store.dispatch(getControls(payload));
                break;
            case BuilderActionsEnum.Registration:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                store.dispatch(changePopupVisibility(PopupEnum.Registration));
                store.dispatch(getControls(payload));
                break;
            case BuilderActionsEnum.ChangeMyProfile:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                if (Auth.isAuthenticated()) {
                    store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
                        tab: ProfileEnum.MyProfile,
                        subTab: 0
                    }));
                    store.dispatch(getPlayerData());
                    store.dispatch(getAccountWallets());
                }
                break;
            case BuilderActionsEnum.ForgotUserName:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                const showLoginFormInline = store.getState().settings.showLoginFormInline;
                if (!Auth.isAuthenticated() && !showLoginFormInline) {
                    store.dispatch(changePopupVisibility(PopupEnum.Login));
                    store.dispatch(getSettingsSuccess(payload));
                } else if (showLoginFormInline) {
                    store.dispatch(getSettingsSuccess(payload));
                }
                break;
            case BuilderActionsEnum.ClosePopup:
                store.dispatch(changePopupVisibility(PopupEnum.Close));
                break;
            case BuilderActionsEnum.ChangeLanguage:
                let newPath = history.location.pathname.replace(`/${LanguageService.getSelectedLanguage()}/`, `/${payload}/`);
                LanguageService.setSelectedLanguage(payload);
                history.replace(newPath);
                window.location.reload();
                break;
            case BuilderActionsEnum.ChangeLogo:
                store.dispatch(updateLogo({ value: payload && payload.value, type: payload && payload.type }))
                break;
            case BuilderActionsEnum.ChangeBanner:
                if (payload.isWidgetBased) {
                    store.dispatch(getBanners(payload.sectionName, Utils.isTablet() ? 'Mobile' : 'Desktop'));
                } else {
                    const siteSections = [Constants.HOME_PAGE_BANNER, Constants.MY_PROFILE, Constants.CASINO_PAGE];
                    const sendSections = {
                        [Constants.HOME_PAGE_BANNER]: Constants.HOME_PAGE,
                        [Constants.MY_PROFILE]: Constants.MY_PROFILE,
                        [Constants.CASINO_PAGE]: Constants.CASINO_PAGE
                    };
                    const selectedSection = siteSections.filter(section => payload.toLowerCase().indexOf(section.replace('_', '').toLowerCase()) === 0)[0]
                    selectedSection && store.dispatch(getBanners(sendSections[selectedSection], Utils.isTablet() ? 'Mobile' : 'Desktop'));
                }
                break;
            case BuilderActionsEnum.ChangeIconSet:
                const styleInnerHtml = payload.innerHtml;
                let spanElement = document.getElementById('tb--icon-set-preview_block')
                if (spanElement) {
                    spanElement.innerHTML = styleInnerHtml;
                } else {
                    spanElement = document.createElement("span")
                    spanElement.setAttribute('id', 'tb--icon-set-preview_block');
                    spanElement.innerHTML = styleInnerHtml;
                    document.body.insertBefore(spanElement, document.body.firstChild)
                }
                break;
            case BuilderActionsEnum.Reload:
                // window.location.reload();
                break;

            case BuilderActionsEnum.ChangePromotion:
            case BuilderActionsEnum.ChangePromotionCategory:
                store.dispatch(setPromotionKey(Math.random()));
                break;
            case BuilderActionsEnum.ChangeBackground:
                store.dispatch(getBackgrounds());
                break;
            case BuilderActionsEnum.UpdateSettings:
                store.dispatch(getSettingsSuccess(payload));
                break;
            case BuilderActionsEnum.UpdateAnnouncement:
                store.dispatch(getSettingsSuccess(payload))
                const showAnnouncements = payload
                showAnnouncements && store.dispatch(getAnnouncements(LanguageService.getSelectedLanguage())).then((res) => {
                    if (!res || !res?.announcements?.filter((i) => (i.announcementContent)).length) {
                        store.dispatch(getSettingsSuccess({ showAnnouncements: false }))
                    }
                })
                break;
            case BuilderActionsEnum.UpdatePopup:
                store.dispatch(changePopupSettings(payload));
                break;
            case BuilderActionsEnum.StoryBlock:
                payload.sectionName && store.dispatch(getStories(payload.sectionName));
                break;
            case BuilderActionsEnum.ChangeDefaultColorMode:
                store.dispatch(getSettingsSuccess(payload));
                LocalStorageService.set('colorMode', { mode: payload, defaultValue: payload });
                store.dispatch(setColorMode(payload));
                break;
            case BuilderActionsEnum.ChangeColorMode:
                store.dispatch(getSettingsSuccess(payload));
                const mode = payload;
                const uiSettingMode = store.getState().settings.uiSettingMode;
                const storeData = LocalStorageService.get('colorMode');
                LocalStorageService.set('colorMode', { mode, defaultValue: (storeData?.defaultValue || uiSettingMode) });
                store.dispatch(setColorMode(mode));
                break;
            case BuilderActionsEnum.MobileApps:
                store.dispatch(getSettingsSuccess({ mobileAppsSettings: payload }));
                break;
            default:
                break;
        }
    },

    handleColorChange: (data, applyToRoot = true) => {
        // const { enableSiteStylesForSport } = store.getState().settings.sportSettings || {};   /**  BLD-19047 */
        // const colorMode = CustomisationHelper.getSelectedColorModeName();


        const styles = {}
        const { payload } = data;

        Object.keys(payload).forEach(color => {
            const colorKey = color.startsWith('--') ? color : `--${color}`;
            if (applyToRoot) {
                document.documentElement.style.setProperty(colorKey, payload[color]);
            }
            styles[colorKey] = payload[color];
        });

        //Sport frame
        window.SportFrame && window.SportFrame.setStyle(JSON.stringify(payload));
        //window.digiAppDispatcher && window.digiAppDispatcher('UPDATE_CSS_VARIABLES', styles);

        const sportInstance = SportHelper.getSportInstance();   
        sportInstance?.changeColors && sportInstance?.changeColors(styles); 

        const esportColors = {
            "Brand": styles['--brand-color-1'],
            "Accent": styles['--brand-color-1'],
            "Background": styles['--background-color-1'],
            "Foreground": styles['--text-color-1']
        };

        window.esportApp && window.esportApp.changeColors({ ...styles, ...esportColors });
        //Sport Top Events
        var topEventsFrame = document.getElementById('sport_top_events');
        var args = {
            command: 'customCssVariables',
            variables: JSON.stringify(payload)
        };

        if (topEventsFrame) {
            topEventsFrame.contentWindow.postMessage(args, "*")
        }

        //Sport Top Matches
        var topMatchesFrame = document.getElementById('sport_top_mathes');
        if (topMatchesFrame) {
            topMatchesFrame.contentWindow.postMessage(args, "*")
        }

        if (window.sportApp) {
            window.sportApp && window.sportApp.changeColors(styles);
        }


        const gameFrame = document.getElementById("gameFrame");
        if (gameFrame) {
            //BetGames
            const betGamesStyles = CustomisationHelper.getBetGamesStyles();
            gameFrame.contentWindow.postMessage({ type: 'change_styles', styles: betGamesStyles }, '*')
            //Virtual Sport
            const vsColors = CustomisationHelper.getVirtualSportStyles();
            gameFrame.contentWindow.postMessage({ eventName: "vs--customization", data: vsColors }, '*')
        }
    }
}

